import { useContext } from "react";

import { ProductsContext } from "@/contexts/productsContext";

export const useProducts = () => {
  const context = useContext(ProductsContext);

  if (!context) {
    throw new Error(
      "useProducts must be used within a ProductsContextProvider"
    );
  }

  return context;
};
